import React from 'react';
import { Button, Space, Tooltip, Typography } from 'antd';
import { CSVLink } from 'react-csv';
import { DownloadOutlined } from '@ant-design/icons';
import { SpeciesV2 } from '../../interfaces';

const { Text } = Typography;

interface Props {
  data: SpeciesV2[];
  filename: string;
  selectedApi?: 'minka' | 'plantnet_plots' | 'plantnet_occurrences' | 'gbif' | 'sinp';
}

const CSVDownloadButton: React.FC<Props> = ({ data, filename, selectedApi }) => {
  const convertToCSV = (data: SpeciesV2[]) => {
    if (!data || data.length === 0) {
      return [];
    }

    const keys = Object.keys(data[0]);
    const header = keys.map((key) => key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()));

    const rows = data.map((species) =>
      keys.map((key) => {
        const value = species[key as keyof SpeciesV2];
        if (Array.isArray(value)) {
          return value.join(', ');
        }
        if (typeof value === 'boolean') {
          return value ? 'Yes' : 'No';
        }
        return value ?? '';
      }),
    );

    return [header, ...rows];
  };

  const citationText = `MINKA Citizen Observatory. EMBIMOS research group, ICM-CSIC.`;

  const button = (
    <Button
      id='speciesDownloadCsvId'
      type='primary'
      style={{
        marginLeft: 10,
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: 'bold',
        borderRadius: '4px',
        padding: '6px 16px',
        backgroundColor: '#4CAF50',
        borderColor: '#4CAF50',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
        transition: 'all 0.3s ease',
      }}
    >
      <CSVLink
        data={convertToCSV(data)}
        filename={filename}
        style={{
          color: 'white',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Space>
          <DownloadOutlined />
          <span>Download CSV</span>
        </Space>
      </CSVLink>
    </Button>
  );

  return (
    <div>
      {selectedApi === 'minka' ? (
        <Tooltip title={citationText} placement='top'>
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
};

export { CSVDownloadButton };
